var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-ellipsis"},[_c('span',{ref:"artMosaic"},[_c('i',{staticClass:"fa fa-ellipsis-h"})]),_vm._v(" "),_c('ArtworkGridTooltip',{attrs:{"refs":_vm.$refs,"artwork":_vm.artwork}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }